/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FRUser, UserManager } from '@forgerock/javascript-sdk';
import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import logo from "../../images/company-logo.png";
import { ReactComponent as Menu } from '../../images/hamburger_icon.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { isLoggedInSelector, toggleLogin } from '../../redux/loginSlice';
import { wc } from '@utdx/rotor-react-wc-shim';
import { useNavigate } from 'react-router-dom';
import LeftNavSection from '../01-atoms/NavBarSections/LeftNavSection';
import { configOptions } from '../../config/index';
export default function Header() {

  const { isLoggedIn, user } = useAppSelector(isLoggedInSelector);

  const navigate = useNavigate();
  const [name, setName] = useState();
  const dispatch = useAppDispatch();
  const windowObject:any=window;

  useEffect(() => {
    (async () => {
      if(!!user){
     
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let userInfo = user ? (user as any).name?.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : user;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setName(userInfo as any);
    }
    })();
  }, [user]);

  const logout = async () => {
    try {
       windowObject.logout()
    } catch {
      throw new Error('Could not log user out');
    }
   
  };

  const showProfile = () => {
    navigate('/myprofile')
  }

  return (
   <>
    <div className="header">
      {/* {isLoggedIn ? <Menu /> : undefined} */}

      <rotor-nav-brand>
      <a href={configOptions.lifeRayURL}><img src={logo} className="logo" alt="CompanyLogo"/></a>
      <rotor-nav-brand-title class='title'> Pratt & Whitney Portal Registration</rotor-nav-brand-title>
        </rotor-nav-brand>
       {/*  {isLoggedIn && <LeftNavSection/> } */}
{/*       {isLoggedIn ?
        <div className="logoutSection">
          <div className='userName'>Welcome, {name}</div>
          <rotor-avatar
            ref={wc({
              events: { rotorclick: showProfile },
              accent: 'accent-1',
              icon: 'rotor-icon-user',
              image: '',
              initials: '',
              isAlert: false,
              isClickable: true
            })}
          />
          <Button onClick={async () => { await logout(); }}>Logout</Button>
        </div> : undefined} */}    
    </div>
    <div className="bannerRegistration"  >
        <div className="leftbanner" >{" US and Non-US Persons "}</div >
        <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
        <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
</>
  );
} 
